import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class FilterClogged extends AlertLogic {
    static type = AlertType.FilterClogged;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = Locale.gettext('Filter Clogged');

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);

        // Varying across alert types
        let cardIllustration = 'garden_cleaning';
        let detailIcon = 'filter';
            
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Clogged equipment'),
            cardDescription: this.locale.gettext('Inspection Required.'),
            cardIllustration: cardIllustration,
            detailIcon: detailIcon,
            detailDescription: this.locale.gettext('We have detected that your equipment is getting clogged in the %1$s', body.Name),
            detailDescription2: this.locale.gettext('First check for debris in your skimmer basket or pump basket. If those are clear, it is time to backwash or clean your filter.'),
            resolveSummary: this.locale.gettext('%1$s flow restored', body.Name)
        });
        alertInfo.contentCategories = FilterClogged.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "Filter");
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                
            }
        }) : null;
    }
}